<script lang="ts">
    import LisTokenIntro from 'src/components/main/token/components/lis-token-intro/LisTokenIntro.svelte'
    import PlayersWillBeAble from 'src/components/main/token/components/players-be-able/PlayersWillBeAble.svelte'
    import GameToken from 'src/components/main/token/components/game-token-scheme/GameTokenSheme.svelte'
    import VisitCommunity from 'src/components/main/#common/visit-community/VisitCommunity.svelte'
    import MainLayout from "../#common/layout/Layout.svelte"
</script>

<svelte:head>
    <title>Realis: Cryptocurrency mobile games on blockchain</title>
    <meta name="description" content="Realis is the world's first platform for launching mobile games with cryptocurrency using blockchain technologies for a mass audience based on Substrate in Polkadot ecosystem."/>
</svelte:head>

<MainLayout>
    <svelte:fragment slot="content">
        <LisTokenIntro/>
        <PlayersWillBeAble/>
        <GameToken/>
        <!--<VisitCommunity/>-->
    </svelte:fragment>
</MainLayout>




